module.exports = __webpack_public_path__ + "static/media/Wi-Fi通信模块.8b731dd7.png";